module.exports = __webpack_public_path__ + "static/media/mono_manual_east_coast.5cf60c33.svg";